<script>
  import logo from './PGConf.svg?no-inline';

  const { color = 'currentColor', ...rest } = $props();
</script>

<svg fill={color} viewBox="0 0 1629 272.5" {...rest}>
  <title>PGConf.dev</title>
  <use href="{logo}#root" />
</svg>
